import React from 'react';
import { SPONSORS, getMainSponsors, getVipSponsors, BONUS_SPONSORS } from '../data/sponsors';
import { SponsorCard } from '../components/SponsorCard';
import { motion } from 'framer-motion';

const Sponsors = () => {
  const mainSponsors = getMainSponsors();
  const vipSponsors = getVipSponsors();

  return (
    <div style={{ padding: '3rem 0' }}>
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title" style={{ fontSize: '2rem' }} data-testid="sponsorlar-page-title">Sponsorlarimiz</h1>
          <p className="section-subtitle">BetMax Gaming Solution's partner platformlari</p>
        </motion.div>

        {/* ANA SPONSORLAR */}
        <div style={{ marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
            <span className="tier-badge tier-badge-main">Ana Sponsorlar</span>
          </div>
          <div className="sponsors-grid">
            {mainSponsors.map((sponsor, idx) => (
              <motion.div
                key={sponsor.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.08 }}
                viewport={{ once: true }}
              >
                <SponsorCard sponsor={sponsor} />
              </motion.div>
            ))}
          </div>
        </div>

        {/* VIP SPONSORLAR */}
        <div style={{ marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
            <span className="tier-badge tier-badge-vip">VIP Sponsorlar</span>
          </div>
          <div className="sponsors-grid">
            {vipSponsors.map((sponsor, idx) => (
              <motion.div
                key={sponsor.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.08 }}
                viewport={{ once: true }}
              >
                <SponsorCard sponsor={sponsor} />
              </motion.div>
            ))}
          </div>
        </div>

        {/* YUKSEK ODEME GARANTISI */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
            <span className="tier-badge tier-badge-bonus">Yuksek Odeme Garantisi</span>
          </div>
          <div className="sponsors-grid">
            {BONUS_SPONSORS.map((sponsor, idx) => (
              <motion.div
                key={sponsor.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.08 }}
                viewport={{ once: true }}
              >
                <SponsorCard sponsor={sponsor} buttonText="KAYIT OL!" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
